import { NotificationManager } from '@atlas/core';

const POPUP_ID = 'storeItemDetails';

export const openStoreItemDetailsPopup = ({
  name,
  itemId,
  image,
  description,
  price,
  discountedPrice,
  purchaseType,
  canBuy,
  pool,
  hintText,
  relatedGames,
  relatedItemIds = [],
  relatedItemsCatalog = [],
  balances = {},
  history,
  ribbon,
}) => {
  if (!name) return false;

  NotificationManager.removeNotification(POPUP_ID);

  NotificationManager.display({
    data: {
      balances,
      canBuy,
      description,
      discountedPrice,
      hintText,
      history,
      image,
      itemId,
      name,
      pool,
      price,
      purchaseType,
      relatedGames,
      relatedItemIds,
      relatedItemsCatalog,
      ribbon,
    },
    id: POPUP_ID,
    type: 'storeItemDetails',
  });

  return true;
};
